import { TaskDrawerSettingsModel } from "../models";
import { TaskDrawerMode } from "../types";

/**
 * Type-guard для настроек шторки задачи
 */
export class TaskDrawerSettingsTypeGuard {
  /**Режим создания */
  static isCreate(
    settings: TaskDrawerSettingsModel<TaskDrawerMode>,
  ): settings is TaskDrawerSettingsModel<"create"> {
    return settings.Mode === "create";
  }
  /**Режим редактирования */
  static isEdit(
    settings: TaskDrawerSettingsModel<TaskDrawerMode>,
  ): settings is TaskDrawerSettingsModel<"edit"> {
    return settings.Mode === "edit";
  }
  /**Режим создания подзадачи */
  static isCreateSubtask(
    settings: TaskDrawerSettingsModel<TaskDrawerMode>,
  ): settings is TaskDrawerSettingsModel<"create-subtask"> {
    return settings.Mode === "create-subtask";
  }
  /**Режим копирования */
  static isCopy(
    settings: TaskDrawerSettingsModel<TaskDrawerMode>,
  ): settings is TaskDrawerSettingsModel<"copy"> {
    return settings.Mode === "copy";
  }
}
